export const toHalfWidthAlnum = (input) => input.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0));
export const toKatakana = (input) => input.replace(/[ぁ-ゖ]/g, (c) => String.fromCharCode(c.charCodeAt(0) + 0x60));
export const stripSeparators = (input) => input.replace(/[\s　・･,，、.。]/g, '');
export const normalizeName = (input) => stripSeparators(toHalfWidthAlnum(input)).normalize('NFKC');
export const normalizeKana = (input) => toKatakana(normalizeName(input));
const KANJI_DIGITS = { 〇: '0', 一: '1', 二: '2', 三: '3', 四: '4', 五: '5', 六: '6', 七: '7', 八: '8', 九: '9' };
export const normalizeAddress = (input) => {
    let v = toHalfWidthAlnum(input).normalize('NFKC');
    v = v.replace(/[〇一二三四五六七八九]/g, (c) => KANJI_DIGITS[c] ?? c);
    v = v.replace(/丁目|番地|番|号|の/g, '-');
    v = v.replace(/[-－‐‑‒–—―ー−]/g, '-');
    v = v.replace(/-+/g, '-').replace(/-$/, '');
    return stripSeparators(v);
};
export const normalizeBirthday = (input) => {
    const m = toHalfWidthAlnum(input).match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);
    if (!m)
        return '';
    return `${m[1]}-${m[2].padStart(2, '0')}-${m[3].padStart(2, '0')}`;
};
//# sourceMappingURL=japaneseText.js.map